import { render, staticRenderFns } from "./TgPremium.vue?vue&type=template&id=5c34745f&"
import script from "./TgPremium.vue?vue&type=script&lang=js&"
export * from "./TgPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports